export default __webpack_public_path__ + "static/media/GMaduroPresidente.52653883.png";